import React from "react";
import PropTypes from "prop-types";
import Container from "./Container";

const SectionTitle = (props) => {
  return (
    <Container
      className={`flex w-full flex-col mt-12 first:mt-0 lg:mt-16 ${
        props.align === "left" ? "" : "items-center text-center"
      }`}
    >
      {props.pretitle && (
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600 sm:text-sm">
          {props.pretitle}
        </p>
      )}
      {props.title && (
        <h2 className="mt-2 max-w-2xl text-2xl font-bold leading-tight tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          {props.title}
        </h2>
      )}
      {props.children && (
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg lg:text-xl">
          {props.children}
        </p>
      )}
    </Container>
  );
};

SectionTitle.propTypes = {
  align: PropTypes.string,
  pretitle: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default SectionTitle;
